(() => {
  const selector = '[data-free-shipping-progress]';

  function formatMoney(cents, currency) {
    return new Intl.NumberFormat('en-PK', {
      style: 'currency',
      currency,
      maximumFractionDigits: 0,
    }).format(cents / 100);
  }

  function getQuantity(bar) {
    const productDetails = bar.closest('.product-details');
    const quantityInput = productDetails?.querySelector('input[name="quantity"]');
    return Math.max(1, Number.parseInt(quantityInput?.value || '1', 10) || 1);
  }

  function getVariantPrice(bar) {
    const productDetails = bar.closest('.product-details');
    const variantInput = productDetails?.querySelector('input[name="id"]:checked, select[name="id"], input[name="id"]');
    const prices = JSON.parse(bar.querySelector('[data-variant-prices]')?.textContent || '{}');
    return Number(prices[variantInput?.value] || bar.dataset.initialPrice || 0);
  }

  function update(bar) {
    const threshold = Number(bar.dataset.threshold);
    const projectedTotal = Number(bar.dataset.cartTotal) + getVariantPrice(bar) * getQuantity(bar);
    const remaining = Math.max(0, threshold - projectedTotal);
    const progress = Math.min(100, (projectedTotal / threshold) * 100);
    const message = bar.querySelector('[data-free-shipping-message]');
    const fill = bar.querySelector('[data-free-shipping-fill]');

    fill.style.width = `${progress}%`;
    bar.classList.toggle('lm-free-shipping-progress--complete', remaining === 0);

    if (remaining === 0) {
      message.textContent = bar.dataset.completeMessage;
    } else {
      message.textContent = bar.dataset.remainingMessage.replace(
        '[amount]',
        formatMoney(remaining, bar.dataset.currency),
      );
    }
  }

  function updateWithin(target) {
    const productDetails = target.closest?.('.product-details');
    productDetails?.querySelectorAll(selector).forEach(update);
  }

  document.addEventListener('input', (event) => {
    if (event.target.matches('input[name="quantity"]')) updateWithin(event.target);
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('input[name="quantity"], input[name="id"], select[name="id"], input[type="radio"]')) {
      requestAnimationFrame(() => updateWithin(event.target));
    }
  });

  document.addEventListener('cart:update', (event) => {
    const cartTotal = event.detail?.resource?.total_price;
    if (cartTotal === undefined) return;

    document.querySelectorAll(selector).forEach((bar) => {
      bar.dataset.cartTotal = String(cartTotal);
      update(bar);
    });
  });

  const initialize = () => {
    document.querySelectorAll(selector).forEach((bar) => {
      if (bar.dataset.shippingProgressInitialized === 'true') return;
      bar.dataset.shippingProgressInitialized = 'true';
      update(bar);
    });
  };
  initialize();

  new MutationObserver(initialize).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
